export default __webpack_public_path__ + "static/media/widgets2.bb89df02.png";